/**
 * Single source of truth for the Buy Bonus vocabulary. Components branch on
 * these, never on raw strings. Same idiom as `jackpotConstants.js`.
 */

// The overlay's own internal screen stack — not the sidebar's, this modal
// lives outside the sidebar/menu navigation entirely (mirrors defenderV2's
// BuyFreebetsOverlay, which is triggered from the betting panel, not the menu).
export const BUY_BONUS_OVERLAY = {
  PACKAGES_LIST: 'PACKAGES_LIST',
  PACKAGE_CHECKOUT: 'PACKAGE_CHECKOUT',
  PACKAGE_PAYMENT_STATUS: 'PACKAGE_PAYMENT_STATUS',
}

export const BUY_BONUS_PAYMENT_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
}

export const BUY_BONUS_TEXTS = {
  PACKAGES_LIST: {
    PAGE_TITLE_LABEL: 'Select the Packages & Buy Freebets',
    BUY_BUTTON_TEXT: 'Buy',
    NUMBER_OF_FREEBETS_LABEL: 'No. of Freebets',
    PACKAGE_AMOUNT_LABEL: 'Amount',
    FREEBET_REWARD_PREFIX: 'FB',
    JACKPOT_RATIO_TEXT: '{x}% more tickets will be allocated in Jackpot',
  },
  PACKAGE_CHECKOUT: {
    PAGE_TITLE_LABEL: 'Payment Details',
    PACKAGE_NAME_LABEL: 'Package Name',
    NUMBER_OF_FREEBETS_LABEL: 'Number of Freebets',
    STAKE_AMOUNT_PER_FREEBET_LABEL: 'Amount of 1 Freebet',
    TOTAL_AMOUNT_LABEL: 'Total Amount',
    JACKPOT_RATIO_LABEL: 'Jackpot Tickets Allocation',
    PROCEED_BUTTON_TEXT: 'Proceed',
    PROCESSING_BUTTON_TEXT: 'Processing...',
  },
  PACKAGE_PAYMENT_STATUS: {
    SUCCESS: {
      MESSAGE: 'Payment Success!',
      ACTION_TEXT: 'Play Freebets Now',
      ACTION_BUTTON_TEXT: 'Play',
    },
    FAILURE: {
      MESSAGE: 'Payment Failed!',
      ACTION_TEXT: 'Buy Freebets Now',
      ACTION_BUTTON_TEXT: 'Buy',
    },
  },
}

export const BUY_BONUS_MESSAGES = {
  EMPTY_PACKAGES_LIST: 'No Packages Available.',
}
